<app-loader *ngIf="isLoading"></app-loader>

<div class="main-container lg-view">
    <h3> Procedure Form Bypass Request </h3>
    <h5> by {{jobProcedureFormBypassRequestDetails.requestDetails.requestedBy}} on  {{ jobProcedureFormBypassRequestDetails.requestedOn | date:'MM/dd/yyyy hh:mm a':'UTC' }}
    </h5>

    <h3 *ngIf="jobProcedureFormBypassRequestDetails.isRequestCompleted">
        <span *ngIf="jobProcedureFormBypassRequestDetails.isApproved" class="text-green">APPROVED</span>
        <span *ngIf="!jobProcedureFormBypassRequestDetails.isApproved" class="text-red">REJECTED</span>
    </h3>
    <h5 *ngIf="jobProcedureFormBypassRequestDetails.isRequestCompleted">
        by {{jobProcedureFormBypassRequestDetails.requestDetails.completedBy}} on {{ jobProcedureFormBypassRequestDetails.completedOn | date:'MM/dd/yyyy hh:mm a':'UTC' }}
    </h5>
    <p *ngIf="!jobProcedureFormBypassRequestDetails.isApproved && jobProcedureFormBypassRequestDetails.comment">
        Comment : {{jobProcedureFormBypassRequestDetails.comment}}
    </p>

    <h4> Please find below more details about the request :</h4>

    <ng-container
            *ngTemplateOutlet="jobProcedureFormBypassRequestDetails.requestDetails.siteName ? infoTemplate : null; context: { label: 'Site', text: jobProcedureFormBypassRequestDetails.requestDetails.siteName }">
    </ng-container>

    <ng-container
            *ngTemplateOutlet="jobProcedureFormBypassRequestDetails.requestDetails.assetName ? infoTemplate : null; context: { label: 'Asset', text: jobProcedureFormBypassRequestDetails.requestDetails.assetName }">
    </ng-container>

    <ng-container
            *ngTemplateOutlet="jobProcedureFormBypassRequestDetails.requestDetails.procedureName ? infoTemplate : null; context: { label: 'Procedure', text: jobProcedureFormBypassRequestDetails.requestDetails.procedureName }">
    </ng-container>

    <ng-container
            *ngTemplateOutlet="jobProcedureFormBypassRequestDetails.requestDetails.formName ? infoTemplate : null; context: { label: 'Form', text: formattedFormName }">
    </ng-container>

    <ng-container
            *ngTemplateOutlet="jobProcedureFormBypassRequestDetails.bypassReason ? infoTemplate : null; context: { label: 'Reason', text: jobProcedureFormBypassRequestDetails.bypassReason }">
    </ng-container>

    <generic-modal #procedureFormBypassResponseModal>
        <ng-template #modalHeading>
            <h3 style="text-align: center; font-weight: 100">The procedure form bypass request</h3>
        </ng-template>

        <ng-template #modalBody>
            <div style="text-align: center;">
                <h4 style="margin-top: 0;">was successfully approved</h4>
            </div>
        </ng-template>

        <ng-template #modalActions>
            <button mat-raised-button class="secondary" type="button" (click)="closeProcedureFormBypassResponseModal()">Ok</button>
        </ng-template>
    </generic-modal>

    <generic-modal #procedureFormBypassResponseModalError>
        <ng-template #modalHeading>
            <h3 style="text-align: center; font-weight: 100">The procedure form bypass request could not be processed</h3>
        </ng-template>

        <ng-template #modalActions>
            <button mat-raised-button class="secondary" type="button" (click)="closeProcedureFormBypassResponseModal()">Ok</button>
        </ng-template>
    </generic-modal>

</div>

<action-button-carousel *ngIf="!jobProcedureFormBypassRequestDetails.isRequestCompleted">
    <ng-template #buttonsTemplate>
        <action-button [clickAction]="submitApprove.bind(self)" @slideUp @fadeIn [icon]="ButtonIcons.StatusChange"
                       [name]="'Approve'"></action-button>

        <action-button [clickAction]="navigateWithData.bind(self, 'reject')" @slideUp @fadeIn [icon]="ButtonIcons.Delete"
                       [name]="'Reject'"></action-button>
    </ng-template>
</action-button-carousel>

<ng-template #infoTemplate let-label="label" let-text="text">
    <div class="job-details">
        <div class="job-details-text">
            <span class="label">{{ label }}</span>
            <span *ngIf="text">{{ text }}</span>
        </div>
    </div>
</ng-template>
